import { createUseStyles } from 'react-jss';
import colors from "../../../utils/colors";



var styles = {
  mobileDropdownButton: {
    width: '3.2rem',
    height: '3.2rem',
    border: 'none',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  mobileDropdownButtonOpened: function mobileDropdownButtonOpened(_ref) {var customMainColor = _ref.customMainColor;return {
      backgroundColor: customMainColor || colors.neutral[700],
      color: colors.neutral.white
    };},
  mobileDropdownButtonClosed: function mobileDropdownButtonClosed(_ref2) {var customMainColor = _ref2.customMainColor;return {
      backgroundColor: colors.neutral.white,
      color: customMainColor || colors.neutral[700]
    };},
  mobileDropdownOption: {
    padding: '1.3rem 1.6rem',
    position: 'relative',
    '&:after': {
      content: '""',
      display: 'block',
      backgroundColor: colors.neutral[200],
      width: '85%',
      height: '0.1rem',
      position: 'absolute',
      bottom: 0,
      left: '7.5%'
    },
    '&:last-of-type': {
      '&:after': {
        display: 'none'
      }
    }
  },
  mobileDropdownLink: {
    color: 'inherit',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center'
  },
  mobileDropdownIcon: {
    display: 'inline-block',
    width: '2.4rem',
    height: '2.4rem'
  },
  mobileDropdownLinkText: {
    marginLeft: '1.1rem'
  }
};
var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map